import React from 'react';
import { Card, Typography, Button, Stack, Box } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import moment from 'moment';

const NotificationCard = ({ notification, onMarkAsRead }) => {
    const { createdAt, title, description, read } = notification;

    return (
        <Card
            sx={{
                mb: 2,
                p: 2,
                backgroundColor: read ? '#f7f7f7' : '#ffffff',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                display: 'flex',
                flexDirection: 'column',
                gap: 1
            }}
        >
            <Stack direction="row" spacing={1} alignItems="center">
                <AccessTimeIcon fontSize="small" sx={{ color: '#808080' }} />
                <Typography variant="caption" sx={{ color: '#808080' }}>
                    {moment(createdAt).format('MMMM DD, YYYY, h:mm A')}
                </Typography>
            </Stack>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1e3a8a' }}>
                {title}
            </Typography>
            <Typography variant="body2" sx={{ color: '#555555', mb: 1 }}>
                {description}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    variant="contained"
                    onClick={onMarkAsRead}
                    sx={{
                        backgroundColor: '#34d399',
                        color: '#ffffff',
                        textTransform: 'none',
                        borderRadius: '20px',
                        boxShadow: 'none',
                        '&:hover': { backgroundColor: '#059669' }
                    }}
                >
                    Mark as Read
                </Button>
            </Box>
        </Card>
    );
};

export default NotificationCard;
